export const ruleName = (rule: string): string => {
  const components = rule.split(".");
  if (components.slice(-1)[0] === "") {
    components.pop();
  }
  return rule.split(".").slice(-1)[0];
};
